// extracted by mini-css-extract-plugin
export default {"wrap":"Hp-z","logoContainer":"Ip-z","brandImg":"Jp-z","logoImg":"Kp-z","logoButton":"Lp-z"};